import { render } from "./InstallWizard.vue?vue&type=template&id=fff39a4c&scoped=true"
import script from "./InstallWizard.vue?vue&type=script&lang=js"
export * from "./InstallWizard.vue?vue&type=script&lang=js"

import "./InstallWizard.vue?vue&type=style&index=0&id=fff39a4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fff39a4c"]])

export default __exports__